import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-case-restore-modal',
    templateUrl: './app-case-restore-modal.component.html',
    standalone: false
})
export class AppCaseRestoreModalComponent implements OnInit, OnDestroy {
    HeaderText = 'AppCaseRestoreModal.header_text';
    BodyText = '';
    ButtonNoText = 'CANCEL';
    ButtonYesText = 'YES_DELETE';
    private destroy$: Subject<boolean> = new Subject<boolean>();
    IsGreenYesButton: boolean = false;
    IsRedNoButton: boolean = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        public dialogRef: MatDialogRef<AppCaseRestoreModalComponent>
    ) {}

    ngOnInit(): void {
        this.modalDataInit();
        this.keydownListener();
    }

    modalDataInit() {
        this.HeaderText = this.data.HeaderText ? this.data.HeaderText : this.HeaderText;
        this.BodyText = this.data.BodyText ? this.data.BodyText : this.BodyText;
        this.ButtonNoText =
            this.data.ButtonNoText == null ? null : this.data.ButtonNoText ? this.data.ButtonNoText : this.ButtonNoText;
        this.ButtonYesText =
            this.data.ButtonYesText == null
                ? null
                : this.data.ButtonYesText
                  ? this.data.ButtonYesText
                  : this.ButtonYesText;
        this.IsGreenYesButton = this.data.IsGreenYesButton ? this.data.IsGreenYesButton : this.IsGreenYesButton;
        this.IsRedNoButton = this.data.IsRedNoButton ? this.data.IsRedNoButton : this.IsRedNoButton;
    }

    keydownListener() {
        this.dialogRef
            .keydownEvents()
            .pipe(takeUntil(this.destroy$))
            .subscribe(event => {
                if (event.key == 'Enter') {
                    this.submitForm();
                }
            });
    }

    submitForm() {
        this.dialogRef.close(true);
    }

    cancel() {
        this.dialogRef.close(false);
    }

    ngOnDestroy(): void {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
}
